<template>
    <div class="mb-5">
        <div class="sm:my-7 mt-8 mb-4 grid grid-flow-col align-center ">
            <h1 :class="`${routeLink + `_fortext`} text-4xl font-Inter font-semibold`">Who’s Nearby?</h1>
            <!-- <div class="w-[350px] self-center">
                <v-text-field placeholder="Search Name Here" :color="colorAsRoute" filled
                    prepend-inner-icon="mdi-magnify" rounded hide-details background-color="white"
                    class="font-Inter font-medium capitalize !text-sm ">
                </v-text-field>
            </div> -->
        </div>
        <div class="flex justify-end">
            <v-btn dark @click="filtersON" class="mb-2" small :color="colorAsRoute" outlined>
                filters <v-icon small right>mdi-filter</v-icon>
            </v-btn>
        </div>
        <v-expand-transition>
            <div v-if="filtersShow"
                class="grid  sm:grid-cols-4 xxs:grid-cols-3 grid-cols-2 gap-3 items-center justify-start">
                <div class="md:w-44">
                    <v-btn dark rounded outlined :color="colorAsRoute" @click="ageRangeShow = true"
                        class="!font-Inter !font-medium capitalize !h-12 !text-xs md:!w-44 !text-clip ">
                        Select Age Range
                    </v-btn>
                    <v-dialog v-model="ageRangeShow" max-width="390">
                        <v-card dark :color="`${routeLink}_color`"
                            :class="`p-[1px]  ${routeLink + `_box-shadow`}  !rounded-[30px] `">
                            <div class="bg-black p-7 !rounded-[30px]">
                                <v-card-subtitle class="white--text !text-xl font-Handel text-center">
                                    Select Age Range
                                </v-card-subtitle>
                                <v-range-slider dark :color="colorAsRoute" v-model="partner_age_range" :max="max" :min="min"
                                    hide-details class="align-center">
                                    <template v-slot:prepend>
                                        <v-text-field :value="partner_age_range[0]" solo dense class="pt-0 mt-0 font-Handel"
                                            :background-color="colorAsRoute" hide-details single-line type="number"
                                            style="width: 65px" @change="$set(partner_age_range, 0, $event)">
                                        </v-text-field>
                                    </template>
                                    <template v-slot:append>
                                        <v-text-field :value="partner_age_range[1]" :background-color="colorAsRoute" solo
                                            dense class="pt-0 mt-0 font-Handel" hide-details single-line type="number"
                                            style="width: 65px" @change="$set(partner_age_range, 1, $event)">
                                        </v-text-field>
                                    </template>
                                </v-range-slider>

                                <v-btn dark text class="!block !ml-auto mt-3"
                                    @click.prevent="searchFilterSet()">Search</v-btn>
                            </div>
                        </v-card>
                    </v-dialog>

                    <!-- <v-text-field placeholder="Distance" dense outlined v-model="distance"
                        :append-icon="!distance ? 'mdi-menu-down' : false" rounded clearable hide-details
                        :color="colorAsRoute" dark
                        :class="`font-Inter font-medium capitalize !text-sm ${routeLink + `_filter`}`">
                    </v-text-field> -->
                </div>
                <div class="md:w-56">
                    <!-- <v-btn dark rounded outlined :color="colorAsRoute" class="!font-Inter !font-medium capitalize !text-sm">
                        Select Hobbies
                    </v-btn> -->

                    <v-select v-model="hobbies" solo dense outlined rounded hide-details :color="colorAsRoute"
                        class="!font-Inter !font-medium capitalize !text-sm scrollbar_hider"
                        :class="`${routeLink}_v-select`" dark :item-color="colorAsRoute" item-text="title" deletable-chips
                        small-chips :items="getInterests" item-value="title" attach chips label="Select Hobbies" />
                    <!-- <v-text-field placeholder="Height" dense outlined v-model="distance"
                        :append-icon="!distance ? 'mdi-menu-down' : false" rounded clearable hide-details
                        :color="colorAsRoute" dark
                        :class="`font-Inter font-medium capitalize !text-sm ${routeLink + `_filter`}`">
                    </v-text-field> -->
                </div>
                <div class="md:w-44">
                    <v-btn dark rounded outlined :color="colorAsRoute" @click.prevent="typesShow = !typesShow"
                        class="!font-Inter !font-medium capitalize !h-12 md:!w-44 !text-xs">
                        Select Type
                    </v-btn>
                    <v-dialog v-model="typesShow" max-width="390">
                        <v-card dark :color="`${routeLink}_color`"
                            :class="`p-[1px]  ${routeLink + `_box-shadow`}  !rounded-[30px] `">
                            <div class="bg-black p-7 !rounded-[30px]">
                                <v-card-subtitle class="white--text !text-xl font-Handel !p-3 text-center">
                                    Select Interest
                                </v-card-subtitle>
                                <v-chip-group :active-class="`${routeLink}_color text-black`" class="" outlined column
                                    v-model="interestTypes">
                                    <v-chip outlined :color="colorAsRoute" class="!px-5 font-Handel" value="3">
                                        Straight
                                    </v-chip>
                                    <v-chip outlined :color="colorAsRoute" class="!px-5 font-Handel" value="1">
                                        Lesbian
                                    </v-chip>
                                    <v-chip outlined :color="colorAsRoute" class="!px-5 font-Handel" value="2">
                                        Gay
                                    </v-chip>
                                </v-chip-group>

                                <v-btn dark text class="!block !ml-auto mt-2"
                                    @click.prevent="searchFilterSet()">Search</v-btn>
                            </div>
                        </v-card>
                    </v-dialog>

                    <!-- <v-text-field placeholder="Weight" dense outlined v-model="distance"
                        :append-icon="!distance ? 'mdi-menu-down' : false" rounded clearable hide-details
                        :color="colorAsRoute" dark
                        :class="`font-Inter font-medium capitalize !text-sm ${routeLink + `_filter`}`">
                    </v-text-field> -->
                </div>
                <div class="md:w-44">
                    <v-chip filter-icon="mdi-check-all" :outlined="!searchByFilter"
                        :text-color="!searchByFilter ? 'grey' : 'black'" dark :input-value="searchByFilter" filter
                        :color="!searchByFilter ? colorAsRoute : `${routeLink + `_color`}`" @click="select"
                        class=" !w-full !h-full !rounded-[50px]  !px-5 !py-3 !font-Inter !font-semibold capitalize !text-sm chip-filter">Online
                        <v-icon color="#00f244 " right size="10">mdi-circle</v-icon> </v-chip>
                </div>
            </div>
        </v-expand-transition>
    </div>
</template>
<script>
export default {

    data() {
        return {
            distance: '',
            selected: false,
            filtersShow: false,
            hobbies: '',
            min: 18,
            max: 50,
            partner_age_range: [18, 50],
            ageRangeShow: false,
            interestTypes: this.$store.getters.StateUser.data.account_type,
            typesShow: false,

        }
    },
    computed: {
        getInterests() {
            return this.$store.getters.interests;
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
        searchByFilter() {
            return this.$store.getters.isStatus;
        }
    },
    methods: {
        filtersON() {
            this.filtersShow = !this.filtersShow
        },
        select() {
            this.selected = !this.selected;
            this.$store.dispatch('searchFilterByStatus')
        },
        searchFilterSet() {
            this.typesShow = false
            this.ageRangeShow = false
            this.$store.dispatch("PremiumSearchFilters", {
                ageFrom: this.partner_age_range[0],
                ageTo: this.partner_age_range[1],
                hobbies: this.hobbies,
                interestType: this.interestTypes
            });
        }
    },
    watch: {
        hobbies: {
            handler() {
                this.searchFilterSet()
            },
            deep: true
        }
    }

}
</script>
<style scoped>
.straight_filter:deep(fieldset) {
    top: 0 !important;
    color: #f2c64f !important;
}

.straight_filter:deep(.v-icon) {
    color: #f2c64f !important;
}

.straight_chip-filter:deep(.v-chip__filter) {
    font-size: 15px !important;
}

.gay_filter:deep(fieldset) {
    top: 0 !important;
    color: #88c3fa !important;
}

.gay_filter:deep(.v-icon) {
    color: #88c3fa !important;
}

.gay_chip-filter:deep(.v-chip__filter) {
    font-size: 15px !important;
}

.lesbian_filter:deep(fieldset) {
    top: 0 !important;
    color: #9e2eec !important;
}

.lesbian_filter:deep(.v-icon) {
    color: #9e2eec !important;
}

.lesbian_chip-filter:deep(.v-chip__filter) {
    font-size: 15px !important;
}

.straight_color {
    /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
    background: rgb(177, 145, 65);
    background: linear-gradient(345deg,
            rgb(97 69 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(90 64 0 / 97%) 100%) !important;
}

.lesbian_color {
    background: rgb(126, 0, 157);
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%) !important;
}

.gay_color {
    background: rgb(0, 240, 255);
    background: linear-gradient(39deg,
            rgba(0, 240, 255, 1) 0%,
            rgba(0, 156, 255, 1) 100%) !important;
}

.btn_gradient_color {
    background: linear-gradient(360deg,
            rgb(147 105 0) 0%,
            rgba(202, 174, 112, 1) 53%,
            rgb(162 115 0 / 97%) 100%) !important;
}

.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(357deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.v-select:deep(.v-input__slot) {
    background-color: transparent !important;
}

.v-select:deep(label) {
    position: initial !important;
    font-size: small;
}

.v-select:deep(.v-menu) {
    z-index: 20 !important;
}

.v-select:deep(.v-list) {
    background-color: #111;
}

/* .v-text-field:deep(.v-input__slot) {
 background-color: #ae8c39 !important;
} */

.straight_v-select:deep(.v-list-item__title),
.straight_v-select:deep(fieldset),
.straight_v-select:deep(label) {
    color: #ae8c39 !important;
    top: 0 !important;
}

.straight_v-select:deep(.v-chip) {
    color: black !important;
    background-color: #ae8c39 !important;
}

.gay_v-select:deep(.v-list-item__title),
.gay_v-select:deep(fieldset),
.gay_v-select:deep(label) {
    color: #88c3fa !important;
    top: 0 !important;
}

.gay_v-select:deep(.v-chip) {
    color: black !important;
    background-color: #88c3fa !important;
}

.lesbian_v-select:deep(.v-list-item__title),
.lesbian_v-select:deep(fieldset),
.lesbian_v-select:deep(label) {
    color: #9e2eec !important;
    top: 0 !important;
}

.lesbian_v-select:deep(.v-chip) {
    color: black !important;
    background-color: #9e2eec !important;
}

.v-input__slider:deep(label) {
    color: white !important;
}

.scrollbar_hider::-webkit-scrollbar {
    display: none !important;
}

.scrollbar_hider:deep(::-webkit-scrollbar) {
    display: none !important;
}

/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar_hider {
    -ms-overflow-style: none !important;
    /* IE and Edge */
    scrollbar-width: none !important;
    /* Firefox */
}

.scrollbar_hider:deep(::-webkit-scrollbar) {
    -ms-overflow-style: none !important;
    /* IE and Edge */
    scrollbar-width: none !important;
    /* Firefox */
}

.v-card:deep(.v-slide-group__content) {
    justify-content: center;
}
</style>